export default __webpack_public_path__ + "src/assets/index/regions_en.xlsx";